import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export interface OrderdadSearchParams {
  orderCompany?: string;
  orderDivision?: string;
  orderNumber?: string;
  supplier?: string;
  claimNumber?: string;
  customUse?: string;
  filters?: Record<string, string>;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

function hasActiveFilters(params: OrderdadSearchParams): boolean {
  const hasBasic = !!(
    params.orderCompany ||
    params.orderDivision ||
    params.orderNumber ||
    params.supplier ||
    params.claimNumber ||
    params.customUse
  );
  const hasDynamic = params.filters
    ? Object.values(params.filters).some((v) => !!v)
    : false;
  return hasBasic || hasDynamic;
}

export function useOrderdadSearch(
  params: OrderdadSearchParams,
  enabled = true,
) {
  const isEnabled = enabled && hasActiveFilters(params);
  const query = useQuery({
    ...orpc.shipAndDebit.orderdadSearch.search.queryOptions({
      input: params,
    }),
    enabled: isEnabled,
    staleTime: 30_000,
  });

  const transactions = isEnabled ? (query.data?.transactions ?? []) : [];

  return {
    ...query,
    transactions,
    records: transactions,
    pagination: isEnabled ? query.data?.pagination : undefined,
    fileMetadata: isEnabled ? (query.data?.fileMetadata ?? []) : [],
    isNotFound: false,
    notFoundMessage: undefined,
  };
}
